import axios from "axios"

export default {
  loadDocuments({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/documents`).then(res => {
        resolve(res.data);
        commit('updateDocuments', res.data);
      }, error => {
        reject(error);
      })
    })
  },
}
